import http from '@yld/yun-utils-http'
import { BASE_URL } from '@yld/yun-utils-host'

const api_30004 = BASE_URL.WG + '/api/30004'

// 订单关键字搜索
export function searchSimpleOrder(data) {
  return http.post(api_30004 + '/order/search/searchSimpleOrder', data)
}
